/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";

function HiddenGroup({ value, field }) {
  const { fieldName } = field;
  return <input type="hidden" name={fieldName} value={value} />;
}

HiddenGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default HiddenGroup;
